import React from "react";

export default function PolicyStatement(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Policy statement, Aims, Objectives & Commitment
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Policy Statement
          </h2>
          <span className="text-gray-700 block mb-4">
            Everyone at Slum Soccer/ Krida Vikas Sanstha (SS/KVS) including
            those associated with SS in any manner have a duty to safeguard and
            protect all children involved in Slum Soccer/ Krida Vikas Sanstha
            projects and programs from harm and abuse through adherence to
            prescribed guidelines, and by giving special attention to the deaf
            children and others who may be particularly vulnerable.
          </span>
          <span className="text-gray-700 block mb-1">
            Through this policy, Slum Soccer/ Krida Vikas Sanstha recognizes
            that:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                All children, whatever their age, culture, disability, gender,
                language, racial origin religious beliefs and/or sexual identity
                have the right to safeguarding and protection from all types of
                harm and/or abuse including be it physical, emotional, sexual,
                neglect or and bullying.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                We have a fundamental duty of care towards all children we
                engage with, including a duty to safeguard and protect them from
                harm and/or abuse.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                All staff working in Slum Soccer/ Krida Vikas Sanstha have a
                responsibility to report cases of poor practices seriously and
                respond swiftly by reporting all suspicions, allegations and
                concerns of child harm/abuse to the appropriate officer without
                loss of time.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Policy Aims and Objectives
          </h2>
          <span className="text-gray-700 block mb-1">
            The aim of the Slum Soccer/ Krida Vikas Sanstha’s Child Safeguarding
            & Protection Policy is to ensure safety of children, observe zero
            tolerance for child harm/abuse and promote good practices by:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Providing children with appropriate safeguard and protection
                from harm/abuse whilst in the care of Slum Soccer/ Krida Vikas
                Sanstha
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Encouraging all adults, parents, children and youth to inform
                Child Protection Officer <b>(CPO)</b> of SS/KVS or any of its
                staff or associates about their concerns regarding safety and
                welfare of child participants during any program/ project/
                event/ activity conducted by SS/KVS
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Making it mandatory for all staff and associates of Slum Soccer
                / Krida Vikas Sanstha to make informed and confident responses
                to specific child safeguarding and protection issues.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Slum Soccer/ Krida Vikas Sanstha’s Commitment
          </h2>
          <span className="text-gray-700 block mb-1">
            Slum Soccer/ Krida Vikas Sanstha is committed to
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Valuing, respecting and listening to children
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensuring all necessary background checks are made when
                recruiting staff
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Sensitizing our associates to support the efforts towards Child
                Safeguarding and Protection
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Maintaining robust child safeguarding and protection systems and
                procedures for its staff to follow.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Training our staff and providing a common understanding of child
                safeguarding and protection issues for uniform planning and
                practice
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Sharing information with children about child safeguarding and
                protection as well as good practices thereof.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Sharing information about concerns with designated agencies as
                per the law and involving parents and children appropriately
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Providing adequate and appropriate resources to implement this
                policy and ensuring that it is communicated and understood by
                all concerned.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
